import React from 'react'

const Playground = ({
    playgroundRef,
    projectsRef,
    list_project,
}) => {
    return (
        <div className="bg-[#FFFFFF] text-gray-900 h-[100vh] flex justify-center flex-col  w-fit"
            ref={playgroundRef}
            id={`playground`}
        >
            <div
                ref={projectsRef}
                className="flex">
                <div className="w-[10vh]"></div>
                {
                    list_project?.map((project, index_project) => {
                        return <>
                            <div className="group relative w-[50vh] h-[50vh] mr-[3vw] bg-white rounded-lg p-[5vh] overflow-hidden border border-gray-200 shadow-md">
                                <div className="text-2xl font-bold tracking-tight text-[#111111] group-hover:text-[#E65445] ">{project?.name}</div>
                                <div className="pt-[2vh] font-normal text-[#111111] ">{project?.description}</div>
                                <div className="pt-[4vh] font-normal text-[#E65445] ">{project?.keyword}</div>
                                <div className="w-full p-[1vh] flex items-center justify-center rounded-full absolute inset-x-0 bottom-0" >
                                    <div className="cursor-pointer mx-[5vh] mb-[2vh] w-[40vh] bg-gray-900 hover:bg-[#E65445] text-white p-[1vh] flex items-center justify-center rounded-full absolute inset-x-0 bottom-0" onClick={() => window.open(project?.url, "_blank")}>Visit</div>
                                </div>
                            </div>
                        </>
                    })
                }
            </div>
        </div>
    )
}

export default Playground